export const generalAction = {
    SET_IS_LOADING: 'SET_IS_LOADING',
    SET_UPDATED_TIME: 'SET_UPDATED_TIME',
    ADD_A_MINUTE: 'ADD_A_MINUTE',
    SET_ERROR: 'SET_ERROR',
    SET_SIDEBAR: 'SET_SIDEBAR',
    SET_CONFIG: 'SET_CONFIG'
}